<script setup lang="ts">
import { provide, defineProps } from 'vue'

const props = defineProps<{ value: string, class?: string }>()
provide('value', props.value)
</script>

<template>
  <div :class="props.class">
    <slot />
  </div>
</template>
